import React from "react";
import {
  Box, TableContainer, Table, TableHead, TableBody, TableRow, TableCell
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {
  render() {
     const advancePaymentData = this.props.advancedPaymentList;
     const advancedPaymentList = this.props.searchData;
  
    return (
      <div>
        <h2 style={{ textAlign: 'center' }}><u>Remove Advance Payment</u></h2>
        <div>&nbsp;</div>
        <h4 style={{ textAlign: 'center' }}>Group : {advancedPaymentList.groupName} - 
        Factory : {advancedPaymentList.factoryName}</h4>
        <div>&nbsp;</div>
        <h4 style={{ textAlign: 'center' }}>From Date ({advancedPaymentList.startDate}) To Date ({advancedPaymentList.endDate})</h4>
        <div>&nbsp;</div>
        <h4 style={{ textAlign: 'center' }}>RouteName - {advancedPaymentList.routeName===undefined ? 'All Routes' : advancedPaymentList.routeName  }</h4>
        <div>&nbsp;</div>
        <h4 style={{ textAlign: 'center' }}>Source : {advancedPaymentList.advanceRequestType === 1? 'Mobile Advance' :advancedPaymentList.advanceRequestType === 2? 'Over Advance' : advancedPaymentList.advanceRequestType ===3? 'Direct Advance' :'All Source'} - 
        Status : {advancedPaymentList.statusID == 1 ? 'Pending' : advancedPaymentList.statusID == 2 ? 'Issue' : advancedPaymentList.statusID == 3 ? 'Reject' : advancedPaymentList.statusID == 4 ? 'Send_To_Deliver' : advancedPaymentList.statusID == 5 ? 'Authorized' : advancedPaymentList.statusID == 5 ? 'Delivered' : 'All Status'}</h4>
        <div>&nbsp;</div>
        <div></div>
        <Box minWidth={1050}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
             <TableRow>
              <TableCell style={{ width: '12.5%' }} align={'left'}>Created Date</TableCell>
              <TableCell style={{ width: '12.5%' }} align={'left'}>Issuing Date</TableCell>
              <TableCell style={{ width: '12.5%' }} align={'left'}>Route Name</TableCell>
              <TableCell style={{ width: '12.5%' }} align={'left'}>Registration Number</TableCell>
              <TableCell style={{ width: '12.5%' }} align={'right'}>Requested Amount (Rs)</TableCell>
              <TableCell style={{ width: '12.5%' }} align={'right'}>Approved Amount (Rs)</TableCell>
              <TableCell style={{ width: '12.5%' }} align={'left'}>Source</TableCell>
              <TableCell style={{ width: '12.5%' }} align={'left'}>Status</TableCell>
            </TableRow>
          </TableHead>

            <TableBody>
                {advancePaymentData.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.effectiveDate.split('T')[0]}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.issuingDate.split('T')[0]}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.routeName}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.registrationNumber}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} 
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.approvedAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}  
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.advanceRequestType === 1 ? "Mobile Advance" : data.advanceRequestType === 2 ? "Over Advance" : "Direct Advance"}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.statusID === 1 ? "Pending" : data.statusID === 2 ? "Issue" : data.statusID === 3 ? "Reject" : data.statusID === 4 ? "Send_To_Deliver" : data.statusID === 5 ? "Authorized" : "Delivered"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    );
  }
}

